import Vue from 'vue';
import Vuex from 'vuex';
import {
    authorization
} from './client/client-states';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    authorization
  },
});
